// @flow
import cn from 'classnames';
import React, { useEffect } from 'react';

import type { LandingThemeType } from '#common/types/model/landing';

import { getMainFontClass, getTitleFontClass } from '../../../../utils/common-helper';
import { getNewsHash } from '../../../../utils/news-helper';


import './style.pcss';

type Props = {
  onClick: () => void,
  onScrollToPacks?: () => void,
  imageUrl: string,
  date: string,
  category: string,
  title: string,
  landingTheme: LandingThemeType,
  isPrivate?: boolean,
  privateJoinText?: string,
  privateDescription?: string
};

const NewsCard = ({
  onClick,
  onScrollToPacks,
  imageUrl,
  date,
  category,
  title,
  landingTheme,
  isPrivate = false,
  privateJoinText = '',
  privateDescription = ''
}: Props) => {
  useEffect(() => {
    const currentHash = window.location.hash;
    const newsHash = getNewsHash(title);
    if (newsHash === currentHash) {
      onClick();
    }
  });

  return (
    <div
      className='news-card'
      onClick={!isPrivate ? onClick : () => {}}
      role='presentation'
    >

      <div className='news-card__image-container'>
        {imageUrl && (
          <img
            className='news-card__image'
            src={imageUrl}
            alt='news'
          />
        )}
        {isPrivate && (
          <div className='news-card__private-wrapper'>
            <div className={`news-card__private-description ${getMainFontClass(landingTheme.mainFont)}`}>{privateDescription}</div>
            <button className='banner-button__join news-card__private-button' onClick={onScrollToPacks}>
              <span className='simple-button__text news-card__private-button-text'>{privateJoinText}</span>
            </button>
          </div>
        )}
      </div>
      <div className='news-card__text'>
        <div className={cn('news-card__top', getMainFontClass(landingTheme.mainFont))}>
          <div>{date}</div>
          <div>{category}</div>
        </div>
        <div className={cn('news-card__title', getTitleFontClass(landingTheme.headerFont))}>
          <h3>{title}</h3>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
